<template>
  <b-container v-if="platform">
    <h1 v-translate>Manage Integrations</h1>
    <b-modal id='IntegrationImportShopifyShippingsMessage' ref='IntegrationImportShopifyShippingsMessage' :hide-footer="true">
      <div slot="modal-title" v-translate>Shipments Import</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <integration-import-shopify-shippings-message :import-count='shipmentsCount' :user-email='this.$store.state.auth.profile.email' :message='message' :success='success' />
    </b-modal>
    <div class="row">
      <div class="col-md-3">
        <company-navigation />
      </div>
      <div class="col-md-9 personal-info">
        <h2>{{platform.name}} -
          <translate>Configuration Panel</translate>
        </h2>
        <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountDown=0" @dismiss-count-down="countDownChanged">
          <h5 v-translate>Integration settings were updated!</h5>
        </b-alert>
        <div v-if="!withAddressMapping">
          <h5 v-translate>Edit the text your client will see in the budget</h5>
          <user-shipping-type-card v-for="shippingType in userShippingType" :key="shippingType.id" :application="application" :user-shipping-type="shippingType" @success-updating="successUpdating" />
        </div>
        <b-tabs pills ref="tabs" v-else>
          <b-tab>
            <template #title>
              <translate>Texts to show in quotes</translate>
            </template>
            <p class="mt-3" v-translate>Edit the text your client will see in the budget</p>
            <user-shipping-type-card v-for="shippingType in userShippingType" :key="shippingType.id" :application="application"  :user-shipping-type="shippingType" @success-updating="successUpdating" />
          </b-tab>
          <b-tab>
            <template #title>
              <span v-translate="{platformName: platform.name}">Your Locations at %{platformName}</span>
              <span class="text-danger" v-if="haveLocationsToFix"><font-awesome-icon icon="exclamation-triangle" size="1x" /></span>
            </template>
            <p class="mt-3" v-translate="{siteName: siteName}">Check if all your stores locations are correctly mapped at %{siteName}</p>
             <location-integration-card v-for="location of locations" :key="location.externalId" :location="location" :application="application"  @success-updating="successUpdating" />
          </b-tab>
        </b-tabs>
      </div>
    </div>

  </b-container>
</template>
<script>
import AddressMixins from '@/mixins/address.mixin.js'
import CompanyNavigation from '@/components/CompanyNavigation'
import UserShippingTypeCard from '@/components/UserShippingTypeCard'
import LocationIntegrationCard from '@/components/LocationIntegrationCard'
import IntegrationImportShopifyShippingsMessage from '@/components/IntegrationImportShopifyShippingsMessage'
import AddressAutocomplete from '@/components/AddressAutocomplete'
import PlacePicker from '@/components/PlacePicker'
import { mapGetters } from 'vuex'

export default {
  name: 'IntegrationSettingsPage',
  components: {
    CompanyNavigation,
    UserShippingTypeCard,
    LocationIntegrationCard,
    IntegrationImportShopifyShippingsMessage,
    AddressAutocomplete,
    PlacePicker
  },
  data() {
    return {
      platform: {},
      application: {},
      userShippingType: [],
      locations: [],
      showDeliveryDay: true,
      dismissSecs: 10,
      success: this.$route.query.success ? this.$route.query.success : 0,
      message: this.$route.query.message ? this.$route.query.message : '',
      shipmentsCount: this.$route.query.shipmentsCount ? this.$route.query.shipmentsCount : null,
      dismissCountDown: 0,
      fields: [{
        key: 'external_link',
        label: this.$gettext('Platform link')
      }],
      platformLocations: [],
      platformLocationEdit: null
    }
  },
  computed: {
    withAddressMapping() {
      return this.platform.slug === 'shopify-v2'
    },
    haveLocationsToFix() {
      return this.locations.findIndex(x => x.addressError) !== -1
    },
    ...mapGetters([
      'user'
    ])
  },
  mixins: [AddressMixins],
  mounted() {
    if (this.$route.query.creation) {
      this.$refs.IntegrationImportShopifyShippingsMessage.show()
    }
    this.fetchUserShippingType()
  },
  methods: {
    successUpdating() {
      this.dismissCountDown = this.dismissSecs
      this.fetchUserShippingType()
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    fetchUserShippingType() {
      if (this.$route.params.slug === 'shopify-v2') return this.microserviceFetch()
      let platformUserAuth = this.$store.state.auth.profile.platform_user_authorizations
      this.platform = platformUserAuth.find(x => x.platform.slug === this.$route.params.slug).platform

      let params = {
        includes: ['platform_user_authorizations', 'shipping_type'],
        filter_groups: [
          {
            filters: [
              {
                key: 'platform_user_authorizations.platform_id',
                operator: 'eq',
                value: this.platform.id
              }
            ]
          }
        ]
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'users/' + this.$store.state.auth.uid + '/shipping-types', {params: params})
        .then(response => {
          this.userShippingType = response.body.data
        })
    },
    async setApplication() {
      const {data: response} = await this.$http.get(this.$appConfig.api.baseUrl + 'platforms')
      const platforms = response.data
      this.platform = platforms.find(x => x.slug === this.$route.params.slug)
      for (const app of this.$store.getters.profile.company.applications) {
        if (!app.webhook_url) continue
        const urlObj = new URL(app.webhook_url)
        const params = new URLSearchParams(urlObj.search)
        if (app.platform && app.platform.id === this.platform.id && params.get('userId') === String(this.user.id)) {
          this.application = app
          return
        }
      }
      return null
    },
    setLocations(data) {
      let indexPickup
      this.locations = data.addresses.map((x, i) => {
        if (x.externalId === 'origin') indexPickup = i
        x._edit = false
        return x
      })

      if (indexPickup && indexPickup !== -1) {
        const [pickup] = this.locations.splice(indexPickup, 1)
        this.locations.unshift(pickup)
      } else {
        this.locations.unshift({ externalId: 'origin', storeName: 'Main pickup point', _edit: false })
      }
      console.log('locations', this.locations)
    },

    async microserviceFetch() {
      await this.setApplication()
      const path = this.$appConfig.integrations.ecommerce.baseUrl + 'shopify/get-store?appId=' + this.application.id
      const headers = { 'x-api-key': this.$appConfig.integrations.ecommerce.header, Authorization: this.application.key }
      const { data } = await this.$http.get(path, { headers })
      this.setLocations(data)
      this.userShippingType = data.metadata.shippingTypes.map((type, index) => {
        return {
          id: index,
          enabled: type.enabled,
          title: type.title,
          description: type.description,
          packaging_days: type.packagingDays,
          show_delivery_days: type.showDeliveryDays,
          amount_for_free_shipping: type.amountForFreeShipping,
          fixed_over_price: type.fixedOverPrice,
          min_price: type.minPrice,
          max_price: type.maxPrice,
          shipping_type: { name: type.type }
        }
      })
    }

  }

}
</script>
